<template>
  <div>package list</div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>
